import gql from 'graphql-tag';

const SEND_LISTING_VISIT_MUTATION = gql`
  mutation trackListingVisit($listingId: ID!) {
    trackListingVisit(listingId: $listingId)
  }
`;

export const trackListingVisit = client => listingId =>
  client.mutate({
    mutation: SEND_LISTING_VISIT_MUTATION,
    variables: { listingId }
  });
